import React from 'react';

import { IColumn, IItem } from '@xcritical/grid';

import { NotificationActions } from '../notification-actions';

import {
  NotificationActionsWrapper,
  NotificationGridCell,
  NotificationGridGeneralSelectCheckboxWrapper,
  NotificationMessage,
} from './styles';
import { GridGeneralSelectCheckbox } from './GridGeneralSelectCheckbox';
import { GridSingleSelectCheckbox } from './GridSingleSelectCheckbox';
import { NotificationMessageContent } from './NotificationMessageContent';

// type NotificationGridItem = Pick<IItem, 'date' | 'notificationDetails'>;

export const GRID_COLUMNS: IColumn[] = [
  {
    field: 'multiselect',
    headerName: (
      <NotificationGridGeneralSelectCheckboxWrapper>
        <GridGeneralSelectCheckbox />
      </NotificationGridGeneralSelectCheckboxWrapper>
    ),
    width: 50,
    render: (_content: string, _field: string, row: IItem) => (
      <NotificationGridCell isRead={row.notificationDetails.isRead}>
        <GridSingleSelectCheckbox id={row.notificationDetails.id} />
      </NotificationGridCell>
    ),
  },
  {
    field: 'date',
    headerName: 'Date',
    width: 120,
    render: (content: string, _field: string, row: IItem) => (
      <NotificationGridCell isRead={row.notificationDetails.isRead}>
        {content}
      </NotificationGridCell>
    ),
  },
  {
    field: 'message',
    headerName: 'Message',
    width: 200,
    render: (_content: string, _field: string, row) => (
      <NotificationGridCell isRead={row.notificationDetails.isRead}>
        <NotificationMessage>
          <NotificationMessageContent
            userId={row.notificationDetails.userId}
            notificationType={row.notificationDetails.notificationType}
            data={row.notificationDetails.data}
          />
        </NotificationMessage>
        <NotificationActionsWrapper>
          <NotificationActions notificationItem={row} />
        </NotificationActionsWrapper>
      </NotificationGridCell>
    ),
  },
].map((column) => ({ ...column, sortable: false, visible: true }));
